import type { EarningsEvent } from "../../services/pulseService";

interface Props {
  events: EarningsEvent[];
}

export function EarningsCalendar({ events }: Props) {
  if (!events.length) {
    return (
      <div className="glass-card p-4 sm:p-5">
        <h3 className="text-sm font-semibold text-surface-200 uppercase tracking-wider mb-3">
          Upcoming Earnings
        </h3>
        <p className="text-sm text-surface-500">No upcoming earnings this week</p>
      </div>
    );
  }

  // Group by date
  const byDate = events.reduce<Record<string, EarningsEvent[]>>((acc, ev) => {
    acc[ev.date] = acc[ev.date] || [];
    acc[ev.date].push(ev);
    return acc;
  }, {});

  return (
    <div className="glass-card p-4 sm:p-5">
      <h3 className="text-sm font-semibold text-surface-200 uppercase tracking-wider mb-3">
        Earnings Calendar
      </h3>
      <div className="space-y-4 max-h-[400px] overflow-y-auto custom-scrollbar">
        {Object.entries(byDate)
          .sort(([a], [b]) => a.localeCompare(b))
          .slice(0, 5)
          .map(([date, evts]) => (
            <div key={date}>
              <div className="text-xs font-medium text-surface-400 mb-1.5 sticky top-0 bg-surface-900/80 backdrop-blur-sm py-1">
                {new Date(date + "T00:00:00").toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
                {evts.slice(0, 8).map((ev, i) => (
                  <div
                    key={`${ev.symbol}-${i}`}
                    className="flex items-center justify-between py-1.5 px-2.5 rounded-lg bg-surface-800/30 border border-surface-700/30"
                  >
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-bold text-surface-100">{ev.symbol}</span>
                      <span className="text-xs px-1.5 py-0.5 rounded bg-surface-700/50 text-surface-400">
                        {ev.hour === "bmo" ? "Pre" : ev.hour === "amc" ? "Post" : "TBD"}
                      </span>
                    </div>
                    {ev.eps_estimate !== 0 && (
                      <span className="text-xs text-surface-400 tabular-nums">
                        Est: ${ev.eps_estimate.toFixed(2)}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
